export { hexAlpha } from './hexAlpha';
